<header class="header">
  <div class="header-inner">
    <a routerLink="/" class="logo-wrapper">
      <img src="images/logo-sca-dark.svg" alt="">
      <strong>Système centrale d'authentification SIGESR</strong>
    </a>
    <div class="dash-header">
      <div class="dash-header-container">
        <ng-container *ngIf="!isLoadingUser && currentUser; else userLoader">
          <self-service [user]="currentUser" [config]="profileConfig" (onChangePassword)="handleChangePassword()"
            (onLogout)="handleLogout()" (onAppSelected)="handleAppSelected($event)"
            (onShowAllApps)="handleShowAllApps()">
          </self-service>
        </ng-container>
        <ng-template #userLoader>
          <div class="user-loader">
            <div class="spinner small"></div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</header>

<main class="main">
  <!-- Section utilisateur fixe -->
  <div class="user-wrapper">
    <div class="user-info">
      <div class="user-info-details">
        <img src="images/avatar.jpg" alt="">
        <div>
          <h4 class="user-info-name">{{ userName }}</h4>
          <p>{{ userEmail }}</p>
          <b>{{ userRole }}</b>
        </div>
      </div>
      <div class="user-info-session">
        <strong>Dernière connexion</strong>
        <p>{{ lastConnection }}</p>
      </div>
    </div>
  </div>

  <!-- Zone scrollable : uniquement la liste des applications -->
  <div class="apps-container">
    <div class="container" id="apps-list">
      <!-- Loader principal -->
      <div *ngIf="isLoading" class="apps-loader">
        <div class="spinner"></div>
        <p>Chargement des applications...</p>
      </div>

      <!-- Contenu chargé -->
      <div *ngIf="!isLoading" class="apps-list">
        <h4>Applications</h4>

        <div *ngIf="accessDeniedApp" class="msg-danger">
          <span>⚠️</span>
          <span>Vous n'avez pas accès à l'application "{{ accessDeniedApp }}"</span>
        </div>

        <div class="apps">
          <a *ngFor="let app of allAppsWithStatus" [attr.href]="app.disabled ? null : app.url"
            [attr.target]="app.disabled ? null : '_blank'" [class.apps-item--disabled]="app.disabled" class="apps-item">
            <img [src]="app.icon || 'images/apps/default.svg'" [alt]="app.name">
            <div class="apps-item-details">
              <div class="title">
                <h5>{{ app.name }}</h5>
                <img *ngIf="!app.disabled" src="images/link-extern.svg" alt="Lien externe" class="external-link-icon">
                <span *ngIf="app.disabled" class="lock-icon">🔒</span>
              </div>
              <p class="apps-details">{{ app.description }}</p>
              <span *ngIf="app.disabled" class="access-message">Accès non autorisé</span>
            </div>
          </a>
        </div>

        <div *ngIf="allAppsWithStatus.length === 0" class="no-apps">
          <p>Aucune application disponible.</p>
        </div>
      </div>
    </div>
  </div>
</main>

<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <small>© 2025 SIGESR. Tous droits réservés.</small>
      <div class="footer-content-partners">
        <img src="images/rep-sn.png" alt="">
        <div class="v-d-32"></div>
        <img src="images/mesri.png" alt="">
        <div class="v-d-32"></div>
        <img src="images/sigesr-logo.svg" alt="">
        <div class="v-d-32"></div>
        <img src="images/campusen.png" alt="">
      </div>
    </div>
  </div>
</footer>